import { LayoutMatrix, LayoutSketch, parseSketch, drawSketch, Point } from "../common";
import { rotate, flip } from "./matrix";

export class BlockModel {
  layout: LayoutMatrix;

  static buildFromSketch(sketch: LayoutSketch): BlockModel {
    return new BlockModel(parseSketch(sketch));
  };

  constructor(layout: LayoutMatrix) {
    this.layout = layout;
  }

  width(): number {
    return this.layout[0].length;
  }

  height(): number {
    return this.layout.length;
  }

  draw(): LayoutSketch {
    return drawSketch(this.layout);
  }

  rotate(): BlockModel {
    return new BlockModel(rotate(this.layout));
  }

  flip(): BlockModel {
    return new BlockModel(flip(this.layout));
  }

  points(): Point[] {
    const width = this.width();
    const height = this.height();
    const points: Point[] = [];
    for(let y=0; y < height; y += 1) {
      for(let x=0; x < width; x += 1) {
        if (this.layout[y][x]) {
          points.push({x, y});
        }
      }
    }
    return points;
  }
}
